export default {
  created() {
    window.userId = this.$auth.user?.id
  },
  beforeUnmount() {
    window.userId = undefined
  }
}
